
interface CardSectionProps {
  title: string;
  children: React.ReactNode;
  className?: string;
}

const CardSection = ({ title, children, className = "" }: CardSectionProps) => {
  return (
    <div className={className}>
      <h4 className="text-sm font-medium text-white/60 mb-2">{title}</h4>
      {children}
    </div>
  );
};

export default CardSection;
